import { Component } from '@angular/core';

import { AuthHttpService } from '../../core/services/api/auth-http.service';
import { ToasterService } from '../../core/services/visual/toaster.service';

@Component({
  selector: 'ltg-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.css']
})
export class RecoverPasswordComponent {
  done = false;

  constructor(private authHttpService: AuthHttpService, private toasterService: ToasterService) { }

  onRecover(email: string) {
    this.authHttpService.recoverPassword(email)
      .subscribe(
        () => this.done = true,
        () => this.toasterService.showErrorTranslating('auth.recoverPassword.error')
      );
  }

}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/auth/recover-password/recover-password.component.ts